module.exports = __webpack_public_path__ + "assets/vuetify.fa6678fb.svg";